<template>
    <oc-tree-internal ref="internal" v-bind="$attrs" :data="dataCopy" :dataProcessed="dataProcessed" v-on="$listeners" :pluginsHandler="pluginsHandler" />
</template>
<script>
import Vue from 'vue'
import PluginsHandler from './helpers/PluginsHandler'
import Settings from '@/helpers/Settings'

const theme = Settings.get('theme')

export default {
    name: 'oc-tree',
    props: {
        reloadOnChangeData: {
            type: Boolean,
            default: true
        },
        plugins: {
            type: Array,
            default: () => {
                return []
            }
        },
        theme: {
            type: String,
            default: 'default'
        },
        data: Array
    },
    data() {
        let pHandler = new PluginsHandler(this.plugins, theme, this.theme)
        return {
            dataCopy: this.data,
            pluginsHandler: pHandler,
            dataProcessed: pHandler.processData(this.data, this),
        }
    },
    created() {
        this.reloadInternalTree(false)
    },
    methods: {
        reloadInternalTree(processData = true) {
            if (processData) {
                this.dataProcessed = this.pluginsHandler.processData(this.data, this)
            }

            this.pluginsHandler = new PluginsHandler(this.plugins, theme, this.theme)

            let pHandler = this.pluginsHandler

            var treeTemplate = `
            <div class="oc-tree" v-class="treeClasses">
                ${pHandler.getSlotContent('beforeTree')}
                <ul>
                    <oc-tree-item :treeObject="treeObject()" v-for="(rowItem, key) in dataProcessed" :rowItem="rowItem" :key="key" />
                </ul>
                ${pHandler.getSlotContent('afterTree')}
            </div>
            `

            var treeRowTemplate = `
                <li
                    v-class="rowClasses"
                    v-bind="rowAttrs"
                    v-on="rowEvents"
                    v-show="${pHandler.rowShow()}"
                    v-if="${pHandler.rowIf()}"
                >
                    ${pHandler.getSlotContent('rowPrepend')}
                    {{rowItem[treeObject.defaultPropertyTitleKey]}}
                    ${pHandler.getSlotContent('rowAfterTitle')}
                    ${pHandler.getSlotContent('rowActions')}
                    ${pHandler.getSlotContent('rowAppend')}

                    <ul
                        v-show="${pHandler.rowSubNodesShow()}"
                        v-if="${pHandler.rowSubNodesIf()}"
                    >
                        <oc-tree-item :treeObject="treeObject" v-for="(row, key) in rowItem.children" :key="key" :rowItem="row"/>
                    </ul>
                </li>
            `

            // create new object to remove object's template cache
            // see: https://github.com/vuejs/vue/issues/7240
            this.$options.components = Object.create(this.$options.components)

            this.$options.components['oc-tree-internal'] = {
                mixins: pHandler.getMixins('treeMixins'),
                template: treeTemplate,
                props: {
                    dataProcessed: Array,
                    data: Array,
                    pluginsHandler: Object
                },
                data() {
                    return {

                        eventBus: new Vue()
                    }
                },
                computed: {
                    treeClasses() {
                        return pHandler.treeClasses(this)
                    }
                },
                provide: {
                    eventBus: this.eventBus,
                },
                methods: {
                    treeObject(){
                        return this
                    }
                },
                components: {
                    'oc-tree-item' : {
                        name: 'oc-tree-item',
                        mixins: pHandler.getMixins('treeRowMixins'),
                        props: {
                            treeObject: Object,
                            rowItem: Object
                        },
                        template: treeRowTemplate,
                        computed: {
                            isFolder() {
                                return Boolean(this.rowItem.children && this.rowItem.children.length)
                            },
                            rowEvents() {
                                return pHandler.rowEvents(this)
                            },
                            rowClasses() {
                                return pHandler.rowClasses(this)
                            },
                            rowAttrs() {
                                return pHandler.rowAttrs(this)
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>
<style>
    [v-cloak] { display:none; }
</style>
